import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const OptionTripleDot = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 8.01 25.34'
  >
    <g>
      <circle
        cx='2.67'
        cy='2.67'
        fill={ color }
        r='2.67'
      />
      <circle
        cx='2.67'
        cy='11.67'
        fill={ color }
        r='2.67'
      />
      <circle
        cx='2.67'
        cy='20.67'
        fill={ color }
        r='2.67'
      />
    </g>
  </svg>
);

OptionTripleDot.propTypes = { ...iconPropTypes };

OptionTripleDot.defaultProps = { ...iconDefaultProps };

export default OptionTripleDot;